// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__IPGUL","loaderOuter":"PageOverlayLoader_loaderOuter__1FbyO"};